import { Link } from "react-router-dom";
import { X, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { isPaidAccess } from "@/lib/plan";
import { useState, useEffect } from "react";

const STORAGE_KEY = "sq_hide_upgrade_banner_until";

export function UpgradeBanner() {
  const { user, currentStore } = useAuth();
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    try {
      const until = localStorage.getItem(STORAGE_KEY);
      if (until && Date.now() < parseInt(until, 10)) {
        setHidden(true);
        return;
      }
    } catch {
      /* ignore */
    }
    setHidden(false);
  }, []);

  if (hidden || !currentStore?.isOwner || !user || isPaidAccess(user)) {
    return null;
  }

  const dismiss = () => {
    const week = 7 * 24 * 60 * 60 * 1000;
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + week));
    } catch {
      /* ignore */
    }
    setHidden(true);
  };

  return (
    <div className="relative overflow-hidden rounded-[1.25rem] bg-[#EDE4FB] px-5 py-5">
      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="font-heading text-lg font-bold leading-snug text-foreground">
            Unlock powerful insights
          </p>
          <p className="mt-1 max-w-md text-sm font-medium text-muted-foreground">
            Unlimited products, analytics, team access & bulk upload from
            ₦5,000/month.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button
            asChild
            size="sm"
            className="h-10 rounded-full px-5 font-semibold shadow-none"
          >
            <Link to="/dashboard/settings#billing">
              <Sparkles className="h-4 w-4" />
              Upgrade
            </Link>
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-9 w-9 rounded-full text-muted-foreground hover:bg-white/60"
            onClick={dismiss}
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
